import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function PrivateRoute({ children, roles }) {
  const { user, loading } = useAuth();
  const isMerchantRole = (role) => ['merchant', 'merchant_admin', 'shop_manager'].includes(role);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="w-10 h-10 border-4 border-[#EC1A23] border-t-transparent rounded-full animate-spin mx-auto mb-3" />
          <p className="text-[#561D1A] text-sm">Loading...</p>
        </div>
      </div>
    );
  }

  if (!user) return <Navigate to="/account" replace />;

  if (roles && !roles.includes(user.role)) {
    if (isMerchantRole(user.role)) return <Navigate to="/merchant" replace />;
    if (user.role === 'admin' || user.role === 'super_admin') return <Navigate to="/admin" replace />;
    return <Navigate to="/profile" replace />;
  }

  return children;
}
